import { render, staticRenderFns } from "./ParentBar.vue?vue&type=template&id=5e4452e1&scoped=true"
import script from "./ParentBar.vue?vue&type=script&lang=js"
export * from "./ParentBar.vue?vue&type=script&lang=js"
import style0 from "./ParentBar.vue?vue&type=style&index=0&id=5e4452e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4452e1",
  null
  
)

export default component.exports